import { Sparkles, Award, Palette, Hammer, ShieldCheck, Truck, Gem } from "lucide-react";

const ITEMS = [
  { icon: Award, text: "IGI Certified Lab Grown Diamonds" },
  { icon: Gem, text: "Premium 14K & 18K Gold" },
  { icon: Palette, text: "Yellow · White · Rose Gold" },
  { icon: Hammer, text: "Handcrafted Luxury Jewelry" },
  { icon: ShieldCheck, text: "Lifetime Quality Guarantee" },
  { icon: Truck, text: "Free Secure Shipping" },
  { icon: Sparkles, text: "Exceptional Craftsmanship" },
];

export const ValueStrip = () => {
  const items = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="value-strip" className="bg-[#0A0A0A] text-white overflow-hidden border-y border-[#C8A165]/25">
      <div className="relative flex whitespace-nowrap">
        <div className="flex animate-value-ticker gap-14 py-4 pr-14">
          {items.map(({ icon: Icon, text }, i) => (
            <span
              key={i}
              className="inline-flex items-center gap-3 label-track text-white/85"
            >
              <Icon size={14} strokeWidth={1.4} className="text-[#C8A165]" />
              <span>{text}</span>
              <span className="text-[#C8A165]/40 pl-8">•</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
